import React from 'react';
import PropTypes from 'prop-types';
import { BasicModal } from '../common/modals/BasicModal';

function DeleteModal({ content, message, onHide, onDelete }) {
  return (
    <BasicModal>
      <div className="modal_content">
        <h3>{content.savingPotDeleteTitle}</h3>
        {message}
      </div>
      <div className="modal_footer">
        <button onClick={onHide}>{content.savingsPotCancelButton}</button>
        <button onClick={onDelete}>
          <strong>{content.savingsPotYesButton}</strong>
        </button>
      </div>
    </BasicModal>
  );
}

DeleteModal.propTypes = {
  onHide: PropTypes.func,
  onDelete: PropTypes.func,
  content: PropTypes.object,
  message: PropTypes.object,
};

export { DeleteModal };
